import { gql } from '@apollo/client';

export const fetchLinkedEntitlementBillingProfile = gql`
  query fetchLinkedEntitlementBillingProfile(
    $id: String!
    $searchLinkedEntitlementParams: SearchLinkedEntitlementParams!
    $transactionAccountId: String
  ) {
    entitlementDetails(id: $id, filters: { transactionAccountId: $transactionAccountId }) {
      id
      transactionAccountId
      linkedEntitlements(searchLinkedEntitlementParams: $searchLinkedEntitlementParams) {
        billingGroupId
      }
    }
  }
`;
